export const VariantTemplateRegistry = {
    "electronics": {
        id: "cat_electronics",
        slug: "electronics",
        displayName: "Electronics",
        icon: "ThunderboltOutlined",
        priority: 100,
        templates: [
            { id: "tpl_color", slug: "color", label: "Color", icon: "🎨", priority: 10, aliases: ["colour", "shade"], units: [] },
            { id: "tpl_storage", slug: "storage", label: "Storage", icon: "💾", priority: 20, aliases: ["capacity", "rom"], units: ["GB", "TB"] },
            { id: "tpl_ram", slug: "ram", label: "RAM", icon: "🧠", priority: 30, aliases: ["memory"], units: ["GB"] },
            { id: "tpl_model", slug: "model", label: "Model", icon: "🏷️", priority: 40, aliases: ["version"], units: [] },
            { id: "tpl_warranty", slug: "warranty", label: "Warranty", icon: "🛡️", priority: 50, aliases: ["guarantee"], units: ["Months", "Years"] }
        ]
    },
    "home-appliances": {
        id: "cat_home_appliances",
        slug: "home-appliances",
        displayName: "Home Appliances",
        icon: "HomeOutlined",
        priority: 200,
        templates: [
            { id: "tpl_capacity", slug: "capacity", label: "Capacity", icon: "⚖️", priority: 10, aliases: ["size"], units: ["Liters", "Kg"] },
            { id: "tpl_color_ha", slug: "color", label: "Color", icon: "🎨", priority: 20, aliases: ["colour"], units: [] },
            { id: "tpl_voltage", slug: "voltage", label: "Voltage", icon: "⚡", priority: 30, aliases: ["volt"], units: ["V"] },
            { id: "tpl_power_rating", slug: "power-rating", label: "Power Rating", icon: "🔌", priority: 40, aliases: ["power", "wattage"], units: ["W", "kW"] },
            { id: "tpl_model_ha", slug: "model", label: "Model", icon: "🏷️", priority: 50, aliases: ["version"], units: [] }
        ]
    },
    "hardware": {
        id: "cat_hardware",
        slug: "hardware",
        displayName: "Hardware",
        icon: "ToolOutlined",
        priority: 300,
        templates: [
            { id: "tpl_length", slug: "length", label: "Length", icon: "📏", priority: 10, aliases: ["size"], units: ["mm", "cm", "m", "inch"] },
            { id: "tpl_diameter", slug: "diameter", label: "Diameter", icon: "⭕", priority: 20, aliases: ["width"], units: ["mm", "cm", "inch"] },
            { id: "tpl_material_hw", slug: "material", label: "Material", icon: "🪵", priority: 30, aliases: ["metal"], units: [] },
            { id: "tpl_finish_hw", slug: "finish", label: "Finish", icon: "✨", priority: 40, aliases: ["coating"], units: [] },
            { id: "tpl_pack_size_hw", slug: "pack-size", label: "Pack Size", icon: "📦", priority: 50, aliases: ["quantity", "pack"], units: ["Pieces"] }
        ]
    },
    "automobile": {
        id: "cat_automobile",
        slug: "automobile",
        displayName: "Automobile",
        icon: "CarOutlined",
        priority: 400,
        templates: [
            { id: "tpl_vehicle_model", slug: "vehicle-model", label: "Vehicle Model", icon: "🚗", priority: 10, aliases: ["car model"], units: [] },
            { id: "tpl_compatibility", slug: "compatibility", label: "Compatibility", icon: "✅", priority: 20, aliases: ["fits"], units: [] },
            { id: "tpl_side", slug: "side", label: "Side", icon: "↔️", priority: 30, aliases: ["direction"], units: [] },
            { id: "tpl_color_auto", slug: "color", label: "Color", icon: "🎨", priority: 40, aliases: ["colour"], units: [] }
        ]
    },
    "furniture": {
        id: "cat_furniture",
        slug: "furniture",
        displayName: "Furniture",
        icon: "BankOutlined",
        priority: 500,
        templates: [
            { id: "tpl_material_furn", slug: "material", label: "Material", icon: "🪵", priority: 10, aliases: ["wood"], units: [] },
            { id: "tpl_color_furn", slug: "color", label: "Color", icon: "🎨", priority: 20, aliases: ["colour"], units: [] },
            { id: "tpl_finish_furn", slug: "finish", label: "Finish", icon: "✨", priority: 30, aliases: ["polish"], units: [] },
            { id: "tpl_size_furn", slug: "size", label: "Size", icon: "📏", priority: 40, aliases: ["dimensions"], units: ["cm", "inch", "feet"] }
        ]
    },
    "household-products": {
        id: "cat_household",
        slug: "household-products",
        displayName: "Household Products",
        icon: "HomeOutlined",
        priority: 600,
        templates: [
            { id: "tpl_weight", slug: "weight", label: "Weight", icon: "⚖️", priority: 10, aliases: ["mass"], units: ["Kilograms (kg)", "Grams (g)", "Pounds (lbs)"] },
            { id: "tpl_volume", slug: "volume", label: "Volume", icon: "💧", priority: 20, aliases: ["liquid"], units: ["Liters (L)", "Milliliters (ml)", "Gallons (gal)"] },
            { id: "tpl_pack_size_house", slug: "pack-size", label: "Pack Size", icon: "📦", priority: 30, aliases: ["quantity", "pack"], units: ["Pieces"] },
            { id: "tpl_fragrance", slug: "fragrance", label: "Fragrance", icon: "🌸", priority: 40, aliases: ["scent"], units: [] }
        ]
    },
    "electrical-supplies": {
        id: "cat_electrical_supplies",
        slug: "electrical-supplies",
        displayName: "Electrical Supplies",
        icon: "BulbOutlined",
        priority: 700,
        templates: [
            { id: "tpl_voltage_elec", slug: "voltage", label: "Voltage", icon: "⚡", priority: 10, aliases: ["volt"], units: ["V"] },
            { id: "tpl_current_rating", slug: "current-rating", label: "Current Rating", icon: "🔌", priority: 20, aliases: ["ampere", "amps"], units: ["A", "mA"] },
            { id: "tpl_length_elec", slug: "length", label: "Length", icon: "📏", priority: 30, aliases: ["size"], units: ["m", "feet"] },
            { id: "tpl_color_elec", slug: "color", label: "Color", icon: "🎨", priority: 40, aliases: ["colour"], units: [] }
        ]
    }
};

/**
 * O(1) Lookup function simulating a future API call.
 * Handles normalization, alias resolution, and sorting by priority.
 */
export const getVariantTemplates = (categoryName) => {
    if (!categoryName) return [];
    
    // Normalize to slug (e.g. "Home Appliances" -> "home-appliances")
    const slug = categoryName.toString().trim().toLowerCase().replace(/\s+/g, '-');
    
    const categoryData = VariantTemplateRegistry[slug];
    if (!categoryData || !categoryData.templates) return [];

    // Return sorted templates based on priority
    return [...categoryData.templates].sort((a, b) => a.priority - b.priority);
};
